var TorsoListView = require('backbone-torso/modules/ListView');
var PortalDataService = require('./../data-utils/PortalDataService');
var documentListWidgetTemplate = require('./documentListWidgetTemplate.hbs');
var documentView = require('./DocumentView');

/**
 * This view renders a List View for documents
 * @class DocumentList
 *
 * @constructor
 * @param options {Object}
 */
module.exports = TorsoListView.extend(PortalDataService.mixin({
  template: documentListWidgetTemplate,
  itemContainer: 'document-list-inject-spot',
  itemView: documentView,

  dataModels:[
    {
      alias: 'appointment',
      modelType: 'appointment',
      id: function() {
        return this._appointmentExternalId;
      }
    },
    {
      alias: 'documents',
      collectionType: 'document',
      dependencies: ['appointment:uploadedFileIds'],
      ids: function() {
        var appointment = this.getFetched('appointment');
        return appointment.get('uploadedFileIds');
      }
    }
  ],

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.appointmentExternalId {String} the external id of the current appointment
   */
  initialize: function(options) {
    this._appointmentExternalId = options.appointmentExternalId;

    this.setCollection(this.getPrivateCollection('documents'));
    this.on('fetched:documents', this._triggerDocumentsUpdatedEvent);
  },

  /**
   * @method hasDocuments
   * @returns {boolean} returns whether list view has documents to display
   */
  hasDocuments: function() {
    return !!this.collection && this.collection.size() > 0;
  },

  /**
   * Trigger 'documents-updated' event for any listening views
   * @method _triggerDocumentsUpdatedEvent
   * @private
   */
  _triggerDocumentsUpdatedEvent: function() {
    this.trigger('documents-updated');
  }
}));
